import FaqSection from '../../components/faqSection.js';

document.querySelectorAll('[data-cl-faqs]').forEach(
  faqList => new FaqSection(faqList));